module.exports = __webpack_public_path__ + "static/media/photo-camera.3a91c71d.svg";